<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物资编号：</span>
        </div>
        <el-input v-model="formData.code" size="small" style="width: 280px" />
      </div>      
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物资名称：</span>
        </div>
        <el-input v-model="formData.materialsName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">规格型号：</span>
        </div>
        <el-input v-model="formData.specification" size="small" style="width: 280px" />
      </div>  
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计量单位：</span>
        </div>
        <el-input v-model="formData.measureUnit" size="small" style="width: 280px" />
      </div>  
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>          
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>        
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Material";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "material-category-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资管理"
        }
      ],
      mainTitle: "添加物资",
      subheading: "",
      formData: {
        categoryName: "",
        categoryDes: ""
      }
    };
  },
  methods: {
    confirm() {
      if (!this.formData.code) {
        nError("请输入物资编号");
        return false;
      }
      if (!this.formData.materialsName) {
        nError("请输入物资名称");
        return false;
      }
      if (!this.formData.measureUnit) {
        nError("请输计量单位");
        return false;
      }
      this.$axios
        .post(api.addManager, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "material-manage"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "material-manage"
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialManage/MaterialManageAdd.vue